import styled from 'styled-components'
import inputBaseStyle from '../inputBaseStyle'

export default styled('input')({
  ...inputBaseStyle,
  backgroundColor: 'white',
  height: '46px',
  width: '100%'
})
